module.exports = __webpack_public_path__ + "img/pick2.923b3fd5.png";